export default {
      id: "octagonal-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#octagonal",
      toString: function () {
        return this.url;
      }
    }